import {TrackingProvider} from '~library/context/tracking/tracking-context';
import {MegaNav} from '~library/organisms/MegaNav/MegaNav';
import {useNewMegaNavExperiment} from '~library/organisms/MegaNav/useNewMegaNavExperiment';
import {MegaNavVariant} from './MegaNavVariant/MegaNavVariant';

export const MegaNavABTest = () => {
  const {inExperiment} = useNewMegaNavExperiment();

  if (inExperiment) {
    return <MegaNavVariant />;
  }

  return (
    <TrackingProvider>
      <MegaNav />
    </TrackingProvider>
  );
};
